import { DataTableSearch } from '@/common/ui/table/data-table-search'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { DataTableFilterSelector } from '@/common/ui/table/data-table-filter-selector'
import { GetBannedPlayerTableData } from '@/modules/manage-player/type'
import { columns } from './constants'
import useQueryGetChannels from '@/modules/manage-player/api/hooks/useQueryGetChannels'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useMemo } from 'react'

interface BannedPlayerTableProps {
	data: GetBannedPlayerTableData[]
	total: number
	isLoading?: boolean
}

export default function BannedPlayerTable({
	data,
	total,
	isLoading,
}: BannedPlayerTableProps) {
	const { data: channelsData } = useQueryGetChannels({
		skip: 0,
		take: 100,
		isActive: true,
	})
	const { setChannelFilter } = useTablePagination()

	const channelOptions = useMemo(
		() =>
			channelsData?.data.map((channel) => ({
				label: channel.name,
				value: channel.name,
			})) || [],
		[channelsData],
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSearch
					placeHolder="ค้นหา..."
					searchHint="สามารถค้นหาด้วย: เบอร์โทร, IP Address, บัญชีธนาคาร, เลขบัญชี"
				/>
				<DataTableResetFilter />
				<DataTableFilterSelector
					options={channelOptions}
					placeholder="เลือกช่องทาง"
					label="ช่องทาง"
					onValueChange={setChannelFilter}
				/>
			</div>
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
